import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';

const About = lazy(() => import('./pages/About').then((m) => ({ default: m.About })));
const Lessons = lazy(() => import('./pages/Lessons').then((m) => ({ default: m.Lessons })));
const Classes = lazy(() => import('./pages/Classes').then((m) => ({ default: m.Classes })));
const Camp = lazy(() => import('./pages/Camp').then((m) => ({ default: m.Camp })));
const Contact = lazy(() => import('./pages/Contact').then((m) => ({ default: m.Contact })));
const Stories = lazy(() => import('./pages/Stories').then((m) => ({ default: m.Stories })));
const Studio = lazy(() => import('./pages/Studio').then((m) => ({ default: m.Studio })));

function PageFallback() {
  return (
    <div className="wrap" style={{ padding: '3rem 0', color: 'var(--ink-soft)' }}>
      Loading…
    </div>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageFallback />}>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="lessons" element={<Lessons />} />
            <Route path="classes" element={<Classes />} />
            <Route path="camp" element={<Camp />} />
            <Route path="stories" element={<Stories />} />
            <Route path="studio" element={<Studio />} />
            <Route path="testimonials" element={<Navigate to="/stories" replace />} />
            <Route path="contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
